import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Stack } from '@yonderland/andes-react';
import { useLabelsOverlay } from './useLabelsOverlay';
export const LabelsOverlayAlpha = ({ showGenderIcon, genderFeatureId, savingsPercentage, priceOverlay, showNewProductLabel, showOnlineExclusiveLabel, showSustainabilityLabel, maxLabels, testId, size, }) => {
    const aemConfiguration = useAemConfig();
    const { market } = aemConfiguration;
    const { labels } = useLabelsOverlay({
        showGenderIcon,
        genderFeatureId,
        savingsPercentage,
        priceOverlay,
        showNewProductLabel,
        showOnlineExclusiveLabel,
        showSustainabilityLabel,
        size,
    });
    const labelsToShow = maxLabels ? maxLabels : market === 'nl' ? 2 : 3;
    if (labels.length === 0) {
        return null;
    }
    return (_jsx(Stack, { direction: "col", testId: testId, gap: "1", children: labels.slice(0, labelsToShow) }));
};
